import { SystemState } from './types'

export const getPractiseConversation = (state: SystemState) => state.practise && state.practise.conversation
export const getPractiseSessionId = (state: SystemState) => state.practise && state.practise._id
export const getPractiseResumeId = (state: SystemState) => state.practise && state.practise.resumeId
export const getPractiseResumeMetdata = (state: SystemState) => state.practise && state.practise.resumeMetadata
export const getPractiseJdid = (state: SystemState) => state.practise && state.practise.jdId
export const getPractiseJdMetadata = (state: SystemState) => state.practise && state.practise.jdMetadata
export const getPractisePreferences = (state: SystemState) => state.practise && state.practise.preferences
